/**
 * Created by bootdo.
 */
import axios from 'axios'
import de from "element-ui/src/locale/lang/de";
import cookie from "js-cookie";

axios.defaults.withCredentials = false;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  for(let p in pending){
    if(pending[p].u === config.url + '&' + config.method) { //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
}

//添加一个请求拦截器
axios.interceptors.request.use(
  config => {
    //请求服务的请求头必须携带Authorization
    let token = ''

    config.headers.Appid = sys_default_appid
    config.headers.client = 3
    /*地址里有token优先用地址里的*/
    if(config.params && config.params.token){
      token = config.params.token
    }else{

      /*是湖南服务就用湖南token，否则用中台token*/
      if(config.url.includes("hnny-platform")){
        token = cookie.get(sys_token_prefix + "hn_token");
      }else{
        token = cookie.get(sys_token_prefix + "token");
      }

    }
    // // 统一用户相关服务
    // if(config.url.includes(SHOPSERVER)||config.url.includes(SYSSERVER)||config.url.includes(ACCOUNTSERVER) || config.url.includes(INFOSERVER)){
    //   // token = 'eyJhbGciOiJSUzI1NiJ9.eyJ1c2VyX2lkIjoiZjlkNThjYzIwMTZjNDRmODhlOGE5MGY1ZThkYTYxZGQiLCJ1c2VyX25hbWUiOiJobmd4X2FkbWluIiwiYXV0aG9yaXRpZXMiOlt7ImF1dGhvcml0eSI6IlJPTEVfYnVzaW5lc3NfZGV2ZWxvcGVyIn1dLCJqdGkiOiJiZjZhYjUxNy0zMjQ5LTQ2NWItODA0YS1kYjJhNWE3NzFhMzgiLCJpYXQiOjE2Nzk0NzgzMzMsImV4cCI6MTcxMTAxNDMzM30.lvqHxvCzHFqz5An0aHnJ9UUY9-6GozC2FtrfbTE1SvuXM9VsTDif0SQ6oDXVrHL10VmyySYEL4Bm1uTWDLVBB5MWbRivB7wp0NT3HC-gi3iRCsWdNKpKPRVL8ibvr7xmQV46oM8YuBE60PSoLIGOVS0RDy6XJVvgL5m-jlKMbyE8Ukp9-6tn0pI08XcfBA9uAZSVeoe6Vn5QrL-QIfO_fMmPOghksqEVnU7GONzkArdYkzZBw88F4pN4F9z7uWv7ziQlFeoCkkWdlP8mX0JGbhiry2mU5eruwOTpcuCfqCqA28TyaOTJgtfRmgMVDiGMjdtJfzJCw1JuddJESL93iA'
    //   config.headers.Appid = sys_default_appid
    // }

    config.headers.Authorization = token;


    return config;
  },
  error => {
    return Promise.reject(error)
  }
);
// 添加一个响应拦截器
axios.interceptors.response.use(function (response) {
  //removePending(response.config);
  if (response.data && response.data.code) {
    if (parseInt(response.data.code) === 401 || parseInt(response.data.code) === 403) {
      //未登录
      window.vue.$router.push({ path: "/login" });
    }
  }
  return response;
}, function (error) {
  // Do something with response error
  return Promise.reject(error);
});

//通用方法
export const POST = (url, params) => {
  return axios.post(`${url}`, params).then(res => res.data)
};

export const POSTFILE = (url, params) => {
  return axios.post(`${url}`, params,{
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => res.data)
};

export const GET = (url, params) => {
  return axios.get(`${url}`, {
    params: params
  }).then(res => res.data)
};

export const GETBUFFER = (url, params) => {
  return axios.get(`${url}`, {
    params: params,
    responseType:'arraybuffer'
  }).then(res => res.data)
};
//拼接请求
export const POSTGET = (url, params) => {
  url+="?"
  for (var key in params) {
    url+=key+"="+params[key]
  }
  return axios({
    method:'post',
    url:`${url}`,
    data:{},
    // responseType:'blob'
  }).then(res => res.data)
};
export const POSTBLOB = (url, params) => {
  return axios({
    method:'post',
    url:`${url}`,
    data:params,
    responseType:'blob'
  }).then(res => res.data)
};
export const POSTBLOBOri = (url, params) => {
  return axios({
    method:'post',
    url:`${url}`,
    data:params,
    responseType:'blob'
  }).then(res => res)
};
export const GETBLOB = (url, params) => {
  return axios.get(`${url}`, {
    params: params,
    responseType:'blob'
  }).then(res => res.data)
};

export const GETBLOBORI = (url, params) => {
  return axios.get(`${url}`, {
    params: params,
    responseType:'blob'
  }).then(res => res)
};



export const GET2 = (url, params) => {
  return axios.get(`${url}`, {
    params: params
  }).then(res => res.data)
};

export const PUT = (url, params) => {
  return axios.put(`${url}`, params).then(res => res.data)
};

export const DELETE = (url, params) => {
  return axios.delete(`${url}`, {
    params: params
  }).then(res => res.data)
};

export const PATCH = (url, params) => {
  return axios.patch(`${url}`, params).then(res => res.data)
};

export const POSTBUFFER = (url, params) => {
  return axios.post(`${url}`, {
    params: params,
    responseType:'arraybuffer'
  }).then(res => res.data)
};

export const POSTHEADER = (url, params) => {
  return axios.post(`${url}`, {
    params:params.params,
    header:params.header || ''
  }).then(res => res.data)
};
//拼接请求
export const GETURL = (url, params) => {
  url+="?"
  for (var key in params) {
    url+=key+"="+params[key]
  }
  return axios({
    method:'get',
    url:`${url}`,
    data:{},
    // responseType:'blob'
  }).then(res => res.data)
};


export const GETHEADER = (url, params) => {
  return axios.get(`${url}`, {
    params:params.params,
    header:params.header || ''
  }).then(res => res.data)
};




// WEBPACK FOOTER //
// ./src/api/index.js